const table = {
    empty: 'Tabelle entählt keine Elemente'
}

export default table